<div class="relative flex w-full flex-col">
  <div
    (click)="toggleDropdown()"
    (keydown.enter)="toggleDropdown()"
    (keydown.space)="toggleDropdown()"
    class="flex items-center justify-center"
  >
    <ng-content select="[asTrigger]" />
  </div>

  <div
    [@openClose]="_dropdownOpen ? 'open' : 'closed'"
    class="absolute  top-full mt-2 min-w-32 rounded-md bg-white text-xs font-normal text-gray-700 shadow-lg ring-1 p-2 ring-black ring-opacity-5 focus:outline-none {{
      _computedClass()
    }}"
  >
    <ng-content />
  </div>
</div>
